import { render, staticRenderFns } from "./CMSPartialTemplate.vue?vue&type=template&id=2b55a174&scoped=true&lang=pug"
import script from "./CMSPartialTemplate.vue?vue&type=script&lang=js"
export * from "./CMSPartialTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b55a174",
  null
  
)

export default component.exports